import React, {Component} from "react";
import {FormattedMessage} from "react-intl";

class AllAdminTitleBar extends Component{


    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="title-1 text-align-left">
                            <FormattedMessage id="app.admin-all-title.title"
                                              defaultMessage="ALL ADMIN USERS"
                                              description=""/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-7">&nbsp;</div>
                    <div className="col-md-1">検索</div>
                    <div className="col-md-4">
                        <input className="form-control" onChange={this.props.handleSearchOnChange} id="admins-search-resp"/>

                    </div>
                </div>


            </div>
        )
    }

}
export  default AllAdminTitleBar;



// WEBPACK FOOTER //
// ./src/components/Admin/AllAdminUsers/AllAdminTitleBar/AllAdminTitleBar.js